import { defineComponent, h } from 'vue';
import { S as Slot } from './slot.mjs';

const singleHtmlTags = /* @__PURE__ */ new Set(["input", "img"]);
const Primitive = defineComponent({
  name: "Primitive",
  inheritAttrs: false,
  props: {
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(props, ctx) {
    const asChild = props.as === "template";
    if (asChild) {
      return () => h(Slot, ctx.attrs, { default: ctx.slots.default });
    }
    const isSingleHtmlTag = typeof props.as === "string" && singleHtmlTags.has(props.as);
    if (isSingleHtmlTag) {
      return () => h(props.as, ctx.attrs);
    }
    return () => h(props.as, ctx.attrs, { default: ctx.slots.default });
  }
});

export { Primitive as P };
//# sourceMappingURL=primitive.mjs.map
